import React from 'react';
import "./experience.css"
import { AiFillHtml5 } from 'react-icons/ai'
import { TbBrandJavascript } from 'react-icons/tb'
import { SiCss3 } from 'react-icons/si'
import { SiChakraui } from 'react-icons/si'
import { FaReact } from 'react-icons/fa'
import { SiExpress } from 'react-icons/si'
import { SiMongodb } from 'react-icons/si'
import { FaNodeJs } from 'react-icons/fa'
// import {AiFillHtml5}from 'react-icons/ai'
const Experience = () => {
  return (
    <section id="skills">
      <h2>My Skills</h2>
      <div className='nav-link skills'>
        <div className="skills-card">
          <div className="container experience_container">
            <div className="experience_frontend">
              <h3 style={{color:"#ffffff"}}>Frontend Development</h3>
              <div className="experience_content">
                <article className='experience_details'>
                  <span className="skills-card-img">
                    < AiFillHtml5 size={40} className='experience-details-icon' />
                  </span>
                  <div>
                    <h4 className="skills-card-name">HTML</h4>
                    <small className='text-light'>Experienced</small>
                  </div>
                </article>
                <article className='experience_details'>
                  <span className="skills-card-img">
                    <SiCss3 size={40} className='experience-details-icon' />
                  </span>
                  <div>
                    <h4 className="skills-card-name">CSS</h4>
                    <small className='text-light'>Intermidiate</small>
                  </div>
                </article>
                <article className='experience_details'>
                  <span className="skills-card-img">
                    <TbBrandJavascript size={40} className='experience-details-icon' />
                  </span>
                  <div>
                    <h4 className="skills-card-name">Javascript</h4>
                    <small className='text-light'>Experienced</small>
                  </div>
                </article>
                <article className='experience_details'>
                  <span className="skills-card-img">
                    <SiChakraui size={40} className='experience-details-icon' />
                  </span>
                  <div>

                    <h4 className="skills-card-name">Chakra Ui</h4>
                    <small className='text-light'>Experienced</small>
                  </div>
                </article>
                <article className='experience_details'>
                  <span className="skills-card-img">
                    <FaReact size={40} className='experience-details-icon' />
                  </span>
                  <div>

                    <h4 className="skills-card-name">React</h4>
                    <small className='text-light'>Experienced</small>
                  </div>
                </article>
              </div>
            </div>
            <div className="experience_backend">
              <h3 style={{color:"#ffffff"}}>Backend Development</h3>
              <div className="experience_content">
                <article className='experience_details'>
                  <span className="skills-card-img">
                    <FaNodeJs size={40} className='experience-details-icon' />
                  </span>
                  <div>

                    <h4 className="skills-card-name">Node Js</h4>
                    <small className='text-light'>Experienced</small>
                  </div>
                </article>
                <article className='experience_details'>
                  <span className="skills-card-img">
                    <SiMongodb size={40} className='experience-details-icon' />
                  </span>
                  <div>

                    <h4 className="skills-card-name">MongoDB</h4>
                    <small className='text-light'>Intermidiate</small>
                  </div>
                </article>
                <article className='experience_details'>
                  <span className="skills-card-img">
                    <TbBrandJavascript size={40} className='experience-details-icon' />
                  </span>
                  <div>

                    <h4 className="skills-card-name">Javascript</h4>
                    <small className='text-light'>Experienced</small>
                  </div>
                </article>
                <article className='experience_details'>
                  <span className="skills-card-img">
                    <SiExpress size={40} className='experience-details-icon' />
                  </span>
                  <div>

                    <h4 className="skills-card-name">Express</h4>
                    <small className='text-light'>Experienced</small>
                  </div>
                </article>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Experience;
